const BlackWhiteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.9572 0.961616C11.9464 0.921437 11.9331 0.881259 11.9197 0.84108C11.8956 0.774116 11.8661 0.712509 11.8313 0.650902C11.7938 0.586616 11.7509 0.52233 11.7054 0.46608C11.6492 0.399116 11.5876 0.337509 11.5206 0.283938C11.4912 0.259831 11.4617 0.238402 11.4323 0.216973C11.3975 0.192866 11.3626 0.171438 11.3251 0.152688C11.2769 0.125902 11.2287 0.104474 11.1779 0.0857235C11.1323 0.0669736 11.0841 0.0509021 11.0333 0.0401878C10.9315 0.0134022 10.8217 9.30611e-06 10.7119 9.30611e-06H1.28543C0.575764 -0.00266926 0 0.573223 0 1.28304V10.7116C0 10.8214 0.0133899 10.9313 0.0401696 11.033C0.0937291 11.2393 0.195492 11.4241 0.334747 11.5768C0.361526 11.6062 0.390984 11.6357 0.42312 11.6652C0.575764 11.8045 0.760544 11.9062 0.966748 11.9598C1.06851 11.9866 1.17831 12 1.28811 12H10.7146C11.4242 12 12 11.4241 12 10.7143V1.28304C11.9973 1.17322 11.9839 1.0634 11.9572 0.961616ZM11.1404 10.7116C11.1404 10.9473 10.9476 11.1402 10.7119 11.1402H5.99866V5.99733H0.856952V1.28304C0.856952 1.04733 1.04977 0.854473 1.28543 0.854473H5.99866V5.99733H11.1404V10.7116Z"
      fill="white"
    />
  </svg>
);

export default BlackWhiteIcon;
